var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item && _vm.item.selection_type !== 'auto')?_c('div',{staticClass:"d-flex align-items-center justify-content-center text-nowrap"},[_vm._v(_vm._s(_vm.servicesText))]):_c('div',{staticClass:"d-flex align-items-center justify-content-center text-nowrap"},[_vm._v("Авто")])
}
var staticRenderFns = []

export { render, staticRenderFns }